import { render, staticRenderFns } from "./Chats.vue?vue&type=template&id=e3f42c0a&scoped=true"
import script from "./Chats.vue?vue&type=script&lang=js"
export * from "./Chats.vue?vue&type=script&lang=js"
import style0 from "./Chats.vue?vue&type=style&index=0&id=e3f42c0a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3f42c0a",
  null
  
)

export default component.exports